import React from 'react'
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import ShopInnerBanner from "./Views/ShopInnerBanner"
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import {
    UiContentWr,

} from "../../components/common/UiPageElements"
import London from "../../../../styles/img/london-img.jpg"
import { UiButtonPrimary, UiButtonIcon } from "../../components/form/UiButton"
import AddToFavourites from "../../../../styles/img/svg/AddToFavourites"
import ProductContent from "./Views/ProductContent"
import { WhatsIncluded } from "./Views/WhatsIncluded"
import TermsImg from '../../../../styles/img/terms-img.jpg';
import Footer from "../../components/footer/Footer"

export default function ProductInformation(props) {

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <ShopInnerBanner title="London Weekend"
                    description="Product Description Text" />
                <UiBannerBottomBar
                    prevPage="Shop"
                    prevPageLink="/ui"
                    currentPage="Product Name"
                    currentPageLink="/ui/incentives-pre-register" />
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="4" xl="4">
                            <UiSingleRow>
                                <UiCol lg="12" xl="12" className="mb-3"><img src={London} className="img-fluid sb-product-info-img sb-product-info-lg" /></UiCol>
                                <UiCol lg="6" xl="6" className="mb-3"><img src={London} className="img-fluid sb-product-info-img sb-product-info-md" /></UiCol>
                                <UiCol lg="6" xl="6"><img src={London} className="img-fluid sb-product-info-img sb-product-info-md" /></UiCol>
                            </UiSingleRow>
                        </UiCol>
                        <UiCol lg="8" xl="8">
                            <ProductContent />
                        </UiCol>
                        <UiCol lg="12" className="mt-5 mb-5">
                            <UiSingleRow>
                                <UiCol lg="9" className="sb-pad-set-right mb-4">
                                    <WhatsIncluded />
                                 </UiCol>
                                 <UiCol lg="3" className="sb-whats-included mb-4">
                                    <img src={TermsImg} className="w-100" />
                                  </UiCol>
                            </UiSingleRow>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <Footer />
            </UiMainWrapper>
        </>
    )
}
